import jsPDF from 'jspdf';
import { getInvoiceCompany } from '../tenantConfig';
import stampImage from '../assets/stamp.png';
import signImage from '../assets/sign.png';

/** Build company tax invoice PDF from stored invoice_data and open in a new tab (no download). */
export function openStoredInvoicePdf(companyInfo, invoiceDetails, pdfSettings, selectedCompany) {
  const co = getInvoiceCompany();
  const doc = new jsPDF();

  doc.setFontSize(15);
  doc.setFont('helvetica', 'bold');
  doc.text(co.legalName, 105, 20, { align: 'center' });
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.text(co.tagline, 105, 28, { align: 'center' });

  doc.setFont('helvetica', 'bold');
  doc.line(10, 35, 200, 35);
  doc.setFontSize(10);
  doc.text(`Date: ${new Date(invoiceDetails.invoiceDate).toLocaleDateString('en-GB')}`, 10, 40);
  doc.text(`Invoice Month: ${invoiceDetails.invoiceMonth || 'N/A'}`, 100, 40, { align: 'center' });
  doc.text(`Tax Invoice No: ${invoiceDetails.invoiceNumber}`, 200, 40, { align: 'right' });

  doc.text(co.detailsLabel, 10, 50);
  doc.setFont('helvetica', 'normal');
  doc.text(co.addressLine1, 10, 55);
  doc.text(co.bankAccountLine, 10, 60);
  doc.text(`TRN: ${co.trn}`, 10, 65);
  doc.text(`IBAN: ${co.iban}`, 10, 70);
  doc.text(`Tel: ${co.tel}`, 10, 75);
  doc.text(`Email: ${co.email}`, 10, 80);
  doc.rect(8, 45, 95, 40);

  doc.setFont('helvetica', 'bold');
  doc.text('Client Details:', 110, 50);
  doc.setFont('helvetica', 'normal');
  const { name, address, contactPerson, trnNo, contactNo } = companyInfo || {};
  doc.text(`Contact Person: ${contactPerson || 'N/A'}`, 110, 55);
  doc.text(`Company: ${selectedCompany || name || 'N/A'}`, 110, 60);

  const wrappedAddress = doc.splitTextToSize(`Address: ${address || 'N/A'}`, 85);
  wrappedAddress.forEach((line, index) => doc.text(line, 110, 65 + index * 5));

  const contactPositionY = 65 + wrappedAddress.length * 5;
  doc.text(`Contact No: ${contactNo || 'N/A'}`, 110, contactPositionY);

  const trnPositionY = contactPositionY + 5;
  doc.text(`TRN: ${trnNo || 'N/A'}`, 110, trnPositionY);

  const rectHeight = trnPositionY - 45 + 5;
  doc.rect(108, 45, 92, rectHeight);

  const tableStartY = 100;
  const rowHeight = 10;
  const colDescriptionX = 15;
  const colAmountX = 180;
  const tableWidth = 190;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.rect(10, tableStartY, tableWidth, rowHeight);
  doc.text('Description', colDescriptionX, tableStartY + 7);
  doc.text('Total Amount (AED)', colAmountX, tableStartY + 7, { align: 'right' });

  doc.setFont('helvetica', 'normal');
  const description = invoiceDetails.description || 'Vehicle washing, greasing and polishing';
  const total = parseFloat(invoiceDetails.totalAmount);
  const subtotal = parseFloat(invoiceDetails.subtotal);
  const vatAmount = parseFloat(invoiceDetails.vatAmount);

  const tableContentY = tableStartY + rowHeight;
  doc.rect(10, tableContentY, tableWidth, rowHeight);
  doc.text(description, colDescriptionX, tableContentY + 7);
  doc.text(subtotal.toFixed(2), colAmountX, tableContentY + 7, { align: 'right' });

  let currentY = tableContentY + rowHeight + 5;
  doc.setFont('helvetica', 'bold');

  const boxWidth = 50;
  const boxStartX = colAmountX - 40;
  const boxStartY = currentY;
  const totalRowsHeight = rowHeight * 3;
  doc.rect(boxStartX, boxStartY, boxWidth, totalRowsHeight);

  doc.line(boxStartX, currentY + rowHeight, boxStartX + boxWidth, currentY + rowHeight);
  doc.text('Subtotal:', boxStartX + 5, currentY + rowHeight - 3);
  doc.text(`${subtotal.toFixed(2)}`, boxStartX + boxWidth - 5, currentY + rowHeight - 3, { align: 'right' });

  currentY += rowHeight;
  doc.line(boxStartX, currentY + rowHeight, boxStartX + boxWidth, currentY + rowHeight);
  doc.text('VAT (5%):', boxStartX + 5, currentY + rowHeight - 3);
  doc.text(`${vatAmount.toFixed(2)}`, boxStartX + boxWidth - 5, currentY + rowHeight - 3, { align: 'right' });

  currentY += rowHeight;
  doc.text('Total:', boxStartX + 5, currentY + rowHeight - 3);
  doc.text(`${total.toFixed(2)}`, boxStartX + boxWidth - 5, currentY + rowHeight - 3, { align: 'right' });

  const footerStartY = currentY + rowHeight + 10;
  doc.setFont('helvetica', 'normal');
  doc.text('Receiver Name:', 140, footerStartY + 30);
  doc.text('Prepared By:', 10, footerStartY + 30);
  doc.text('Rec Sign & Stamp:', 140, footerStartY + 40);
  doc.text('Checked By:', 10, footerStartY + 40);

  const settings = pdfSettings || {};
  if (settings.includeSignature && co.showStampAndSign !== false) {
    try {
      doc.addImage(signImage, 'PNG', 20, footerStartY + 28, 45, 22);
    } catch (error) {
      console.error('Error adding signature image:', error);
    }
  }
  if (settings.includeStamp && co.showStampAndSign !== false) {
    try {
      doc.addImage(stampImage, 'PNG', 87, footerStartY + 45, 37, 37);
    } catch (error) {
      console.error('Error adding stamp image:', error);
    }
  }

  doc.setFont('helvetica', 'bold');
  doc.text('Thanks, and regards', 10, footerStartY + 75);
  doc.setFont('helvetica', 'normal');
  doc.text(co.footerBehalf, 10, footerStartY + 85);

  if (co.signatoryName) {
    doc.setFont('helvetica', 'bold');
    doc.text(co.signatoryName, 10, footerStartY + 95);
  }
  doc.setFont('helvetica', 'normal');
  if (co.signatoryPhone1) doc.text(co.signatoryPhone1, 10, footerStartY + 105);
  if (co.signatoryPhone2) doc.text(co.signatoryPhone2, 10, footerStartY + 115);

  const blobUrl = doc.output('bloburl');
  window.open(blobUrl, '_blank');
}
